import BaseEvent, { BaseGetEvent, IBaseEvent } from './BaseEvent';

export interface ISelectEvent extends IBaseEvent {
  type: 'select';
  toJSON(): BaseGetEvent & {
    type: ISelectEvent['type'];
    value: string | number;
  };
}

export default class SelectEvent extends BaseEvent implements ISelectEvent {
  type = 'select' as const;

  private value: string | number;

  constructor({
    description,
    value,
  }: {
    description: string;
    value: string | number;
  }) {
    super(description);
    this.value = value;
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      value: this.value,
    };
  }
}
